module.exports = __webpack_public_path__ + "static/media/crocodile(26).3377b040.PNG";